import { createSlice } from "@reduxjs/toolkit";
import { ViewSettings } from "./FieldSettingsApi";

const SettingsSlice = createSlice({
  name: "settings",
  initialState: {
    settingData: [],
  },

  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(ViewSettings.fulfilled, (state, action) => {
      state.settingData = action.payload?.data?.field_setting;
    });
  },
});

export default SettingsSlice.reducer;
